import React from 'react';

import sortIcon from 'assets/images/sort-arrow.png';
import { LOCALE, withTranslation } from 'providers/GILT.provider';
import { formatDateByLocale } from 'utils/date/format.util';
import parsfixed from 'utils/values/parsfixed.util';

import { STOCK_LAST_MOVEMENT_PDF_TABLE_ID } from 'stocks/consts';

import CN from './TableLastStockMovement.module.scss';

class TableLastStockMovement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    this.getWindowScrollTop();
    // document.addEventListener('mousedown', this.handleClickOutside);
  }
  getWindowScrollTop = () => {
    if (window.pageYOffset) {
      return window.pageYOffset;
    } else if (document.documentElement) {
      return document.documentElement.scrollTop;
    }
    return 0;
  };

  searchFunc = (el) =>
    el
      .getName()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .toLocaleString(LOCALE.uk)
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[\u00E9]/g, '')
      .search(this.props.search) !== -1 ||
    el
      .getBrand()
      .trim()
      .normalize('NFD')
      .replace(/^0+'/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .toLocaleString(LOCALE.uk)
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    el
      .getFamily()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .toLocaleString(LOCALE.uk)
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    el
      .getCategory()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .toLocaleString(LOCALE.uk)
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    (el.barcode ? el.barcode.toString() : '')
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1;

  render() {
    const categoryKeys = this.props.data.filter(this.searchFunc);
    const { t } = this.props;
    return (
      <div data-bem="TableLastStockMovement">
        <table id={STOCK_LAST_MOVEMENT_PDF_TABLE_ID} data-bem="TableLastStockMovement__table-header" className={CN.container}>
          <thead>
            <tr>
              <th className="brand-name">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    this.props.onAddSort('brand');
                  }}
                >
                  <span>{t('stocks.tableHeaders.brand')}</span>
                  <img src={sortIcon} alt="Sort by Brand" />
                </span>
              </th>
              <th className="product-name">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    this.props.onAddSort('title');
                  }}
                >
                  <span>{t('stocks.tableHeaders.productName')}</span>
                  <img src={sortIcon} alt="Sort by product" />
                </span>
              </th>
              {/* Coming soon */}
              {/* <td className="category">
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                          this.props.onAddSort('category');
                        }}
                  >
                    <span>Category</span>
                    <img src={sortIcon} alt="Sort by Category" />
                  </span>
                </td> */}
              <th style={{ width: '100px' }}>
                <span
                  role="button"
                  tabIndex={0}
                  className="two-lines sm"
                  onClick={() => {
                    this.props.onAddSort('quantity');
                  }}
                >
                  <span>{t('stocks.tableHeaders.stockQuantity')}</span>
                  <img src={sortIcon} alt="Sort by Category" />
                </span>
              </th>
              <th style={{ width: '100px' }}>
                <span
                  role="button"
                  tabIndex={0}
                  className="two-lines sm"
                  onClick={() => {
                    this.props.onAddSort('dateOfLastChange');
                  }}
                >
                  <span>{t('stocks.tableHeaders.lastChangeDate')}</span>
                  <img src={sortIcon} alt="Sort by used" />
                </span>
              </th>
              <th style={{ width: '100px' }}>
                <span
                  role="button"
                  tabIndex={0}
                  className="two-lines sm"
                  onClick={() => {
                    this.props.onAddSort('amountLastChange');
                  }}
                >
                  <span>{t('stocks.tableHeaders.lastChangeAmount')}</span>
                  <img src={sortIcon} alt="Sort by sold" />
                </span>
              </th>
              <th style={{ width: '100px' }}>
                <span
                  role="button"
                  tabIndex={0}
                  className="two-lines sm"
                  onClick={() => {
                    this.props.onAddSort('typeOfLastChange');
                  }}
                >
                  <span>{t('stocks.tableHeaders.lastChangeType')}</span>
                  <img src={sortIcon} alt="Sort by cost used" />
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {categoryKeys.map((key) => {
              const stocks = key;
              return (
                <tr key={stocks.id}>
                  <td
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                    role="button"
                    tabIndex={0}
                    className="brand-name"
                    onClick={() => {
                      this.props.OnClickRow(stocks);
                    }}
                  >
                    <span>{stocks.brand ? stocks.brand : t('common.unknown')}</span>
                  </td>
                  <td
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                    role="button"
                    tabIndex={0}
                    className="product-name"
                    onClick={() => {
                      this.props.OnClickRow(stocks);
                    }}
                  >
                    {stocks.title}
                  </td>
                  {/* Coming soon */}
                  {/* <td className="category">
                                  Category
                          </td> */}
                  <td style={{ width: '98px', textAlign: 'center' }}>{parsfixed(stocks.units_in_stock)}</td>
                  <td style={{ width: '98px', textAlign: 'center' }}>
                    {/* TODO: date localization */}
                    {stocks.latest_change ? formatDateByLocale(stocks.latest_change.timestamp, { dateFormat: 'DD-MM-YYYY' }) : ''}
                  </td>
                  <td style={{ width: '98px', textAlign: 'center' }}>{stocks.latest_change ? parsfixed(stocks.latest_change.amount) : 0}</td>
                  <td style={{ width: '98px', textAlign: 'center' }}>
                    {stocks.latest_change && stocks.latest_change.type
                      ? stocks.latest_change.type.charAt(0).toUpperCase() + stocks.latest_change.type.slice(1).replace('_', ' ')
                      : t('stocks.stockLastMovementTable.newIn')}
                  </td>
                </tr>
              );
            })}
            {categoryKeys.length === 0 && (
              <tr>
                <td colSpan={6} className={CN.noProductsMsg}>
                  {t('stocks.stockManagerTable.noProductsMsg')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

const TableLastStockMovementHoc = withTranslation()(TableLastStockMovement);
export default TableLastStockMovementHoc;
